import React from "react";
import {TextInput} from "react-native";
import P from "../lib/P";
import Div from "../lib/Div";
import MainStyle from "../../MainStyle";
import {outline_0} from "../constants";
import {FormikProps} from "formik";
import DateTimePicker from "./DateTimePicker/DateTimePicker";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import moment from "moment";
import Dropdown from "./Dropdown";
import {Gender} from "../../generated/smg_service_pb";
import {getFieldError} from "../utils";
import {HelperText} from "react-native-paper";

type Props = { formik: FormikProps<any>, name?: string, divider?: boolean, label: string, readonly?: boolean };

const genderItems = [{value: Gender.MALE, label: 'Male'}, {value: Gender.FEMALE, label: 'Female'}];

// Gender arrives as a numeric wire enum — always render its label, never the raw number.
const genderLabel = (value: Gender): string => genderItems.find(el => el.value === value)?.label ?? 'N/A';

const FullSwingProfileField = ({formik, name, divider, label, readonly}: Props) => {
  return (
    <Div row alignItems="center" px={16}>
      <P fontFamily="DavisSans-Regular" color="#76777A">{label}</P>

      {!name ? (
        <P fontFamily="DavisSans-Regular" flex={1} ta="right" lh={55}>N/A</P>
      ) : readonly ? (
        <Div flex={1} row alignItems="center" h={55}>
          <P fontFamily="DavisSans-Regular" flex={1} ta="right" color="#BBBCBF" mr={10}>
            {(name === 'dateOfBirth' && formik.values[name]) ? moment(formik.values[name]).format('MM/DD/YYYY') : name === 'gender' ? genderLabel(formik.values[name]) : formik.values[name]}
          </P>
          <FontAwesome name="lock" size={20} color="#BBBCBF"/>
        </Div>
      ) : name === 'dateOfBirth' ? (
        <Div flex={1}>
          <DateTimePicker
            formik={formik} hideIcon h="55px" textAlign="right" fs="16px" bg="transparent" hideBorder variant="outlined"
          />
        </Div>
      ) : name === 'handedness' ? (
        <Dropdown
          formik={formik} field={name} items={[{value: 'left', label: 'Left'}, {value: 'right', label: 'Right'}]}
          variant="button" label={label}
        />
      ) : name === 'gender' ? (
        <Dropdown formik={formik} field={name} variant="button" label={label} items={genderItems}/>
      ) : name ? (
        <TextInput
          style={styles.input} keyboardType={name === 'email' ? 'email-address' : 'default'}
          value={formik.values[name]} onChangeText={formik.handleChange(name)}
          onBlur={formik.handleBlur(name)}
        />
      ) : null}

      {(name === 'username' && !!getFieldError('username', formik)) ? (
        <Div row alignItems="center" position="absolute" bottom={-3} left={16}>
          <HelperText type="error" visible={true} style={{margin: 0, padding: 0}} padding="none">
            {getFieldError('username', formik) as string}
          </HelperText>
        </Div>
      ) : (name === 'dateOfBirth' && !!getFieldError('dateOfBirth', formik)) ? (
        <Div row alignItems="center" position="absolute" bottom={-3} left={16}>
          <HelperText type="error" visible={true} style={{margin: 0, padding: 0}} padding="none">
            {getFieldError('dateOfBirth', formik) as string}
          </HelperText>
        </Div>
      ) : null}

      {divider && <Div position="absolute" h={1} bottom={0} left={16} right={0} bg="#494A4C"/>}
    </Div>
  );
};

const styles = {
  input: [MainStyle.DavisSans400, MainStyle.l_h_55, MainStyle.flex1, MainStyle.t_a_r, MainStyle.c_white, outline_0]
};

export default FullSwingProfileField;
